import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import datadog from '@nerdwallet/datadog';

import fetchFromCCPrequalService from './cc-prequal-sdk';
import getErrorHandlers from './error-handling';
import PREQUAL_SERVICE_ISSUERS from '../config/prequal-service-issuers';
import verticalInformation from '../config/vertical-definitions';
import {
  NOTFOUND_ERROR_MSG,
  PREQUAL_ISSUER_NOTFOUND_ERROR_MSG,
} from './errors';

/**
 * MAIN FUNCTION
 */
export default async ({ store, res, req, match }) => {
  const { handleNotFound } = getErrorHandlers({
    req,
    res,
    store,
    service: 'interstitial-client',
  });

  const ROUTE_CATEGORY = 'prequalify/credit-cards';
  const routeVerticalSlug = match.params.slug;
  const vertical = verticalInformation[routeVerticalSlug];
  if (!vertical) {
    handleNotFound({
      product: {
        category: ROUTE_CATEGORY,
        id: match.params.id,
      },
    });
    throw new Error(NOTFOUND_ERROR_MSG);
  }

  const clickId =
    _.get(req, 'query.shopping_finish_id') ||
    _.get(req, 'query.finish_id') ||
    uuidv4().replace(/-/g, '');

  const issuer = _.get(req, 'query.issuer', '');
  const offer = _.get(req, 'query.offer', ''); // Amex (url encoded string)
  const prequalId = _.get(req, 'query.prequal_id', ''); // Amex (id in finproservices prequal table)
  const sourceCode = _.get(req, 'query.sourceCode', ''); // Chase (id in cc-prequal-service)
  const userId = _.get(req, 'query.user_id', ''); // Chase

  const productSlug = _.get(req, 'query.clickHeader_productSlug', '');
  const productId = _.get(req, 'query.clickHeader_productId', match.params.id);

  const affiliateId = _.get(PREQUAL_SERVICE_ISSUERS, `${issuer}.affiliateId`);
  const monetizing = true;
  const sponsored = true;

  const basicClientData = {
    gtmEvent: vertical.gtmEvent,
    issuer,
    monetizing,
    productId,
    quantcastLabel: vertical.quantcastLabel,
    redirectType: 'prequal',
    referPath: req.headers['referer'], // eslint-disable-line
  };

  const basicLoggerData = {
    affiliateId,
    category: vertical.category,
    issuer,
    monetizing: true,
    offer,
    prequalId,
    productId,
    productSlug,
    sponsored,
    uniqueClickId: clickId,
    userId,
    verticalEventFields: vertical.eventFields,
    verticalProductType: vertical.productType,
    product: {
      uniqueClickId: clickId,
      productId,
      productSlug,
      category: vertical.category,
      monetizing,
      sponsored,
      affiliateId,
    },
  };

  const extractFromCCPrequalResponse = (issuerName, prequalResponse) => {
    const clientData = {
      ...basicClientData,
      [issuerName]: prequalResponse,
    };
    const loggerData = {
      ...basicLoggerData,
    };

    return {
      clientData,
      loggerData,
    };
  };

  const createPostData = () => {
    const basePostData = {
      click_id: clickId,
      issuers: [issuer],
    };
    if (issuer === 'chase') {
      return {
        ...basePostData,
        sourceCode,
      };
    }
    if (issuer === 'american_express') {
      return {
        ...basePostData,
        offer,
      };
    }
    return basePostData;
  };

  /**
   * Fetch from CC Prequal
   */
  if (issuer in PREQUAL_SERVICE_ISSUERS) {
    const postData = createPostData();
    const response = await fetchFromCCPrequalService({
      postData,
      req,
      res,
      store,
    });

    datadog.increment(
      `interstitial_client.fetch_redirect_details.cc_prequal_service.success`,
      1,
      { tags: { product_type: vertical?.productType } }
    );

    const { clientData, loggerData } = extractFromCCPrequalResponse(
      issuer,
      response
    );
    return { clientData, loggerData };
  }
  handleNotFound({
    product: {
      category: ROUTE_CATEGORY,
      id: match.params.id,
      productType: vertical?.productType,
    },
  });
  throw new Error(PREQUAL_ISSUER_NOTFOUND_ERROR_MSG);
};
